export default __webpack_public_path__ + "static/media/sort-ascending.9bfebb59.svg";